/**
 * 📅 Last Modified: 04 Feb, 2023
 */
import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import { Input } from '../../components';
import Button from '../../components/ui/button';
import HelpLinePopup from '../../components/popups/HelpLinePopup';
import { LoginSchema } from '../../utils/schema';
import { regionalLogin } from '../../service';

export default function RegionLogin() {
  const navigate = useNavigate();

  const [emailSent, setEmailStatus] = useState(false);

  const submitHandler = async (values, {}) => {
    try {
      const response = await regionalLogin({ ...values, organization: '650bd89479ba3ae92524955b' });

      if (response?.status === 200) {
        setEmailStatus(true);
      } else toast.error('Your login was unsuccessful');
    } catch (error) {
      const message = error.response.data.message || 'Something went wrong';
      console.log('ERROR', error.response.data.message);
      toast.error(message);
    } finally {
      formik.setSubmitting(false);
    }
  };

  const resendEmail = async () => {
    try {
      const response = await regionalLogin(formik.values);

      if (response?.status === 200) {
        toast.success('Email Sent again');
        closeModal();
      } else toast.error('Your login was unsuccessful');
    } catch (error) {
      console.log('ERROR', error);
      toast.error(error.message);
    } finally {
      formik.setSubmitting(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: LoginSchema,
    onSubmit: submitHandler
  });

  useEffect(() => {
    localStorage.setItem('lang', 'fr');
    localStorage.setItem('theme', 'fr');
    let token = localStorage.getItem('token');
    if (token) navigate('/my-profile');
  }, []);

  const closeModal = () => {
    formik.resetForm();
    setEmailStatus(false);
  };

  return (
    <>
      <section className="" data-testid="login-form">
        {emailSent ? (
          <HelpLinePopup
            title={'Un e-mail t’a été envoyé !'}
            description={'Vérifie dans ta boîte à lettre et le dossier des mails indésirables'}
            icon={'fr-email-sent'}
            resendEmail={resendEmail}
            closeModal={closeModal}
            data-testid="email-sent-popup"
          />
        ) : (
          <LoginForm formik={formik} />
        )}
      </section>
      {/* <Popups.HelpLinePopup/> */}
    </>
  );
}

const LoginForm = ({ formik }) => {
  return (
    <div className="w-full h-screen flex flex-col">
      <div className="px-4 py-8 mx-2 bg-cblue-500/20 rounded-b-3xl">
        <h1 className="text-xl font-bold text-cblue-500 text-center mb-2 px-2">
          48ème édition de la Compétition nationale des métiers en région Sud
        </h1>
        <p className="text-center text-cblue-500 font-bold uppercase text-2xl">
          16-18 octobre 2025
        </p>
      </div>

      <div className="mt-24 mx-10 text-center">
        <h1 className="text-3xl font-bold quickSand">Merci</h1>
        <p className="quickSand">de contribuer au blog vidéo !</p>
      </div>
      <form className="mt-2 mx-10" onSubmit={formik.handleSubmit}>
        <Input
          className="mb-3"
          name="email"
          placeholder="E-mail"
          data-testid="email-field"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.email}
          error={formik.errors.email}
          touched={formik.touched.email}
        />

        <Button.ButtonRounded
          loading={formik.isSubmitting}
          className="mx-auto bg-cblue-500 rounded-xl shadow-md text-xl py-3 px-4 text-white"
          type="submit"
          data-testid="submit-button">
          Je commence
        </Button.ButtonRounded>
      </form>
    </div>
  );
};
